import React from 'react'
import {
  Header,
  Label,
  Form,
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'

class ImportSelectionPane extends React.Component {
  constructor(props) {
    super(props);
    // props: selection, selections, onImport
    const selection = this.props.selection;
    this.state = {
      id: selection.id,
      idError: this.getIdError(selection.id),
      author: selection.author?selection.author:'',
      name: selection.name?selection.name:'',
      description: selection.description?selection.description:'',
      selection: selection,
    }
  }
  getIdError = (id)=>{
    const existingSelection = this.props.selections.find(s=>s.id===id);
    return existingSelection?"A selection with this ID already exists":undefined;
  }
  handleIdChange = (e, {value})=>{
    console.log("ImportSelectionPane::handleIdChange()", e, value);
    value = value.replace(/[^0-9a-zA-Z]/g, "");
    this.setState({
      id: value,
      idError: this.getIdError(value)
    });
  }
  handleChange = (e, { name, value })=>{
    console.log("ImportSelectionPane::handleChange()", e, name, value);
    this.setState({ [name]: value });
  }
  handleSubmit = ()=>{
    console.log("ImportSelectionPane::handleSubmit()");
    console.log("state:", this.state);
    const selection = {...this.state.selection};
    selection.id = this.state.id;
    selection.name = this.state.name;
    selection.author = this.state.author;
    selection.description = this.state.description;
    this.props.onImport(selection);
    this.props.history.push('/selection/'+selection.id);
  }
  render() {
    //const keys = Object.keys(this.state.selection.items);
    //const topicCount = keys.filter(k=>k.indexOf('.')>-1).length;
    //const outcomeCount = keys.filter(k=>k.indexOf('o')>-1).length;
    return (
      <div>
        <Header as='h2'>Import</Header>
        <p>
          Before importing,
          you may want to update the information about this selection
          (but you can always update this later, too):
        </p>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group widths='equal'>
            <Form.Input
              fluid
              name='id'
              label='ID'
              error={!!this.state.idError}
              value={this.state.id}
              placeholder='Unique ID (e.g., abbreviation) of this selection'
              onChange={this.handleIdChange}
            />
        {
          this.state.idError?
            <Label basic color='red' pointing='left'>
              {this.state.idError}
            </Label>
          :<span></span>
        }
            <Form.Input
              fluid
              name='author'
              label='Author'
              value={this.state.author}
              placeholder='Who created this selection'
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Input
            fluid
            name='name'
            label='Name'
            value={this.state.name}
            placeholder='Full name of this selection'
            onChange={this.handleChange}
          />
          <Form.TextArea
            name='description'
            label='Description'
            value={this.state.description}
            placeholder='Description of this selection...'
            onChange={this.handleChange}
          />
          <Form.Button disabled={!!this.state.idError} color='orange'>Import</Form.Button>
        </Form>
      </div>
    );
  }
}

export default withRouter(ImportSelectionPane)